import { createMuiTheme } from '@material-ui/core'
import { themeConstructor } from './themeConstructor'
import { greenPalette as palette } from '../palettes'

export const greenTheme = createMuiTheme({
  ...themeConstructor(palette), // default theme
  palette, // override color schema
})
